/**
 * Required attachments on app assignment metadata (relationships, app slug attachments).
 *
 * metadata.required_attachments: string[] | { title: string }[]
 * Legacy alias: required_attachment_titles
 */

export function normalizeAttachmentTitle(value) {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

export function parseRequiredAttachmentTitles(metadata) {
  if (!metadata || typeof metadata !== 'object') return [];
  const raw = metadata.required_attachments ?? metadata.required_attachment_titles;
  if (!Array.isArray(raw)) return [];
  const titles = [];
  raw.forEach((item) => {
    if (typeof item === 'string') {
      const t = item.trim();
      if (t) titles.push(t);
      return;
    }
    if (item && typeof item === 'object') {
      const t = String(item.title ?? item.label ?? '').trim();
      if (t) titles.push(t);
    }
  });
  return titles;
}

/**
 * @returns {{ requiredSlots: Array<{ requiredTitle: string, missing: boolean, doc: object|null }>, extraDocuments: object[] }}
 */
export function buildAttachmentDisplayModel(documents, metadata) {
  const requiredTitles = parseRequiredAttachmentTitles(metadata);
  const docs = Array.isArray(documents) ? documents : [];
  const usedDocIds = new Set();

  const requiredSlots = requiredTitles.map((requiredTitle) => {
    const normRequired = normalizeAttachmentTitle(requiredTitle);
    const doc = docs.find(
      (d) =>
        d?.id != null &&
        !usedDocIds.has(d.id) &&
        normalizeAttachmentTitle(d.title) === normRequired
    );
    if (doc) usedDocIds.add(doc.id);
    return {
      requiredTitle,
      missing: !doc,
      doc: doc || null
    };
  });

  const extraDocuments = docs.filter((d) => d?.id != null && !usedDocIds.has(d.id));

  return { requiredSlots, extraDocuments, requiredTitles };
}

export function countMissingRequiredAttachments(documents, metadata) {
  const { requiredSlots } = buildAttachmentDisplayModel(documents, metadata);
  return requiredSlots.filter((s) => s.missing).length;
}
